import { Search } from '@vkontakte/vkui';
import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Полоса поиска над списком: поле в рамке и, если есть что заводить, кнопка
 * рядом.
 *
 * Рамка своя, потому что токенами её не выдать: у вкуишного Search есть
 * только цвет заливки, а он у Мезы почти совпадает с фоном страницы — поле
 * получалось невидимым, лупа и подпись висели в воздухе. Заливку VKUI внутри
 * рамки гасим через его же переменную, иначе внутри коробки рисуется вторая.
 *
 * Кнопка живёт ЗДЕСЬ, а не отдельной строкой под поиском: «завести» относится
 * к тому же списку, что и поиск, и в макетах они стоят одной полосой. Полосой
 * во всю ширину она была только потому, что её некуда было приткнуть.
 */
export function SearchField({
  value,
  onChange,
  placeholder,
  action,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  action?: ReactNode;
}) {
  return (
    <div className={clsx(styles.filterRow, styles.searchRow)}>
      <div className={styles.searchField}>
        <Search
          noPadding
          value={value}
          placeholder={placeholder}
          onChange={(event) => onChange(event.target.value)}
        />
      </div>
      {action}
    </div>
  );
}
